import { useTranslation } from 'react-i18next';

import { SocialCoin } from '../../../components/SocialCoin/SocialCoin';
import { SweepCoin } from '../../../components/SweepCoin/SweepCoin';
import { formatValueWithK } from '../../../utils/helpers';

import classes from './BonusCards.module.scss';

export default function WinAmount(props: { gcAmount: number; scAmount: number }) {
  const social = props.gcAmount != 0;
  const Coin = social ? SocialCoin : SweepCoin;
  const { t } = useTranslation();

  return (
    <div className={classes.winAmount}>
      <Coin className={classes.coin} />
      <span>{social ? formatValueWithK(props.gcAmount, t) : props.scAmount}</span>
    </div>
  );
}
